import React from "react";
import { Drawer, Form, Button, Col, Row, Input } from "antd";
import { useTranslation } from "react-i18next";

import Api from "../../../api";
import "../../../public/sass/components/drawer/_createDrawers.scss";
import { toastNotification } from "../../../utils/toastNotification";

export const CreateSales = ({
  isVisible,
  onClose,
  handleGetAllSalesSevrices,
  generalId,
}) => {
  const [form] = Form.useForm();
  const [t, i18n] = useTranslation();

  const handleSubmit = (formValues) => {
    formValues.general_id = generalId;
    Api("sales-service", "POST", formValues)
      .then(() => {
        toastNotification("success", "Support created successfully");
        handleGetAllSalesSevrices();
        onClose();
      })
      .catch((err) =>
        toastNotification("error", err.error || "Error while creating support")
      );
  };

  return (
    <Drawer
      title={t("add_sales_service")}
      width={720}
      onClose={onClose}
      visible={isVisible}
      className="body-style"
      destroyOnClose
      footer={
        <div className="footer-style">
          <Button onClick={onClose} className="button-style">
            {t("cancel")}
          </Button>
          <Button
            type="primary"
            form="users-form"
            key="submit"
            htmlType="submit"
          >
            {t("submit")}
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        id="users-form"
        layout="vertical"
        scrollToFirstError
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="contact"
              label={t("title")}
              rules={[{ required: true, message: `${t("title")}` }]}
            >
              <Input placeholder={t("enter_tel")} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};
